// components/seating-chart/SeatingChartImage.js
import React, { useEffect, useState } from "react";
import { Image as KonvaImage } from "react-konva";

const SeatingChartImage = ({ shape, draggable, shapeRefs, onSelect, onDragEnd, onTransformEnd }) => {
  const [img, setImg] = useState(null);

  useEffect(() => {
    const image = new window.Image();
    image.crossOrigin = "anonymous";
    image.src = shape.src;
    image.onload = () => setImg(image);
  }, [shape.src]);

  if (!img) return null;

  return (
    <KonvaImage
      image={img}
      x={shape.x}
      y={shape.y}
      width={shape.width}
      height={shape.height}
      rotation={shape.rotation}
      draggable={draggable}
      onClick={(e) => onSelect(e, shape.id)}
      onDragEnd={(e) => onDragEnd(e, shape.id)}
      onTransformEnd={(e) => onTransformEnd(e, shape.id)}
      ref={(node) => {
        if (shapeRefs?.current) shapeRefs.current[shape.id] = node;
      }}
    />
  );
};

export default SeatingChartImage;